module.exports = __webpack_public_path__ + "assets/img/thumb-Blackpurl-Landing-Page.af97de68.webp";